import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription, take } from 'rxjs';
import { SafeResourceUrl } from '@angular/platform-browser';
import { IUserInformation } from '@interfaces/userInformation';
import { MatDialog } from '@angular/material/dialog';
import { OrganizationPopupComponent } from '@components/organization-popup/organization-popup.component';
import { AppState } from '../app.state';
import { Store } from '@ngrx/store';
import * as UserActions from '@state/actions/user-profile.actions';
import * as UserInfoSelectors from '@state/selectors/user-profile.selectors';
import { AppSettings } from '../shared/Constants/sharedConstants';
import { AuthService } from '@services/auth.service';
import { OrganizationService } from '@services/organization.service';
import { Router } from '@angular/router';
import { ThemeSettingsService } from '@services/theme-settings.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  @Input() logoHyperlink;
  @Input() logoSource;

  dangerousResourceURL: string;
  trustedResourceURL: SafeResourceUrl;

  sub: Subscription;
  currentCSOsub: Subscription;
  parentOrganizationTree: any[] = [];
  userId: number = 0;
  copyOrgTree: string;
  tooltipText: string = 'Copy the organization details';
  themeEnabled: boolean;

  public buildInfo: string = null;
  public userProfileData$: Observable<IUserInformation>;


  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
    private organizationService: OrganizationService,
    public translate: TranslateService,
    private router: Router,
    private themeService: ThemeSettingsService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    //user service get data
    this.userProfileData$ = this.store.select(
      UserInfoSelectors.selectUserInformation,
    );

    // get the logged-in user id
    this.store
      .select(UserInfoSelectors.selectUserInformation)
      .pipe(take(1))
      .subscribe((userInfo) => {
      if (userInfo) {
          this.userId = userInfo.userId;
        }
       });

    //When the CSO changes are detected, we go out to the webAPI and retrieve the parentOrgTree and bind.
    this.currentCSOsub = this.store
      .select(UserInfoSelectors.selectCsoId)
      .subscribe((orgId) => {
        if (orgId < 1) return;
        //get a new list of Parent Organization Tree items
        this.organizationService
          .getParentOrganizationTree(orgId)
          .subscribe((r) => {
            this.store.dispatch(new UserActions.GetParentOrganizationTree(r));
            this.parentOrganizationTree = r;
            this.copyOrgTree = r.map((x) => x.organizationName).join(' / ');
          });
      });

    this.buildInfo = AppSettings.buildInfo;

    this.themeService.themeEnabled$.subscribe((enabled) => {
      this.themeEnabled = enabled;
    });
  }

  get showBuildInfo(): boolean {
    if (this.buildInfo !== null && this.buildInfo.length > 0) {
      return true;
    }

    return false;
  }

  openCSODialog() {
    this.dialog.open(OrganizationPopupComponent, {
      data: {
        UserProfileDTO$: this.userProfileData$,
      },
      panelClass: 'cso-dialog',
    });
  }

  onVersionCheckboxClick() {
    AppSettings.showBuildInfo = !AppSettings.showBuildInfo;
    AppSettings.showBuildInfo$.next(AppSettings.showBuildInfo);
  }

  logout() {
    this.router.navigate(['logout']);
  }

  myAccount() {
    // link to my account page
    const url = ['my-account'];
    this.router.navigate(url);
  }

  copyText() {
    const textToCopy = document.getElementById('textToCopy')?.textContent;
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy).then(
        () => {
          this.tooltipText = 'Copied';
          setTimeout(() => {
            this.tooltipText = 'Copy the organization details';
          }, 2000);
        },
        (err) => {
          console.error('Failed to copy text:', err);
        }
      );
    }
  }
}
